import { render, staticRenderFns } from "./SupervisionSafetyRecommendation.vue?vue&type=template&id=652745e4"
import script from "./SupervisionSafetyRecommendation.vue?vue&type=script&lang=js"
export * from "./SupervisionSafetyRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports